import React, {useEffect, useState} from 'react'
import './styles/otros-documentos.css'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import {Link} from 'react-router-dom'
import CardMenu from '../../components/CardMenu/CardMenu'
import {useDispatch, useSelector} from 'react-redux'
import {setActiveModuleDoc} from '../../actions/documentos/documentos.actions'
import {State} from '../../reducers'
import {
  getActividadesEconomicas,
  getDepartamentos,
  getTiposDocumento,
} from '../../actions/catalogos.actions'
import {generalOpenModalError, generalShowLoader} from '../../actions/general.actions'
import { BannerElegirSucursal } from '../../components/Banner/BannerElegirSucursal'

const cards = [
  {
    titulo: 'Factura de exportación',
    descripcion: 'Es un documento de carácter obligatorio que estipula las vías por las que transita el producto de un país a otro, es decir, mediante el transporte terrestre, marítimo o aéreo. Por lo que, si deseas exportar algún tipo de artículo a nivel internacional, deberás tramitar también la factura de exportación.',
    to: '/otros-documentos/factura-exportacion',
    activo: 5,
    id: '11',
    disabled: false,
    autoFocus: true,
  },
  {
    titulo: 'Factura de sujeto excluido',
    descripcion: 'Es una persona o empresa que no está obligada a pagar el Impuesto al Valor Agregado (IVA) ni a emitir facturas con este impuesto incluido en sus ventas. Esto puede ser porque sus ingresos son muy bajos o porque realizan actividades económicas que están específicamente exentas de IVA.',
    to: '/otros-documentos/sujeto-excluido/formulario',
    activo: 6,
    id: '14',
    disabled: false,
  },
  {
    titulo: 'Comprobante de liquidación',
    descripcion: 'Es un documento que muestra cómo se llegó a un resultado financiero en una transacción, como una venta o un contrato. Ayuda a documentar y respaldar acuerdos financieros y legales.',
    to: '/otros-documentos/comprobante-liquidacion',
    activo: 2,
    id: '08',
    disabled: false,
  },
  {
    titulo: 'Comprobante retención',
    descripcion: 'Es un registro de impuestos descontados de los ingresos antes de recibir el pago final. Se usa para el cumplimiento fiscal y asegurar que las deducciones fiscales sean correctas.',
    to: '/otros-documentos/comprobante-retencion/formulario',
    activo: 3,
    id: '7',
    disabled: false,
  },
  {
    titulo: 'Documento contable de liquidación',
    descripcion: 'Es un comprobante de pago fiscal emitido por emisor electrónico que, por causas no imputables, no puede emitir un comprobante electrónico.',
    to: '/otros-documentos/liquidacion',
    activo: 4,
    id: '09',
    disabled: false,
  },
  {
    titulo: 'Nota de remisión',
    descripcion: 'Es un documento mercantil de control y uso interno de la empresa, que se utiliza para validar la entrega y recepción de un determinado pedido de artículos o productos.',
    to: '/otros-documentos/nota-remision',
    activo: 8,
    id: '04',
    disabled: false,
  },
  {
    titulo: 'Nota de débito (Formato físico)',
    descripcion: 'Es un documento contable y financiero que se utiliza para registrar o notificar una operación donde hay un incremento en el monto que un deudor debe a su acreedor.',
    to: '/otros-documentos/nota-debito-externo',
    activo: 10,
    id: '06',
  },
  {
    titulo: 'Nota de crédito (Formato físico)',
    descripcion: 'Es un comprobante contable por medio del cual se le notifica al cliente el reembolso o deducción a su cuenta de una determinada suma de dinero.',
    to: '/otros-documentos/nota-credito-externo',
    activo: 9,
    id: '05',
    disabled: false,
  },
]

const OtrosDocumentosIndex = () => {
  const [activo, setActivo] = useState(0)
  const dispatch = useDispatch()
  const {actividadesEconomicas, departamentos, tipoDocumento} = useSelector(
    (state: State) => state.catalogos
  )

  const handleActiveDoc = (card: any) => {
    dispatch(setActiveModuleDoc({title: card.titulo, idDoc: card.id}))
  }

  const verificarCatalogos = async () => {
    try {
      dispatch(generalShowLoader(true))
      await Promise.all([
        actividadesEconomicas.length === 0 && dispatch(getActividadesEconomicas()),
        tipoDocumento.length === 0 && dispatch(getTiposDocumento()),
        departamentos.length === 0 && dispatch(getDepartamentos()),
      ])
    } catch (error) {
      dispatch(
        generalOpenModalError('Ocurrió un error al cargar los catalogos para esta funcionalidad.')
      )
    } finally {
      dispatch(generalShowLoader(false))
    }
  }

  useEffect(() => {
    verificarCatalogos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/home'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Otros Documentos</h3>
      </div>
      <div className='separador'></div>
      <BannerElegirSucursal />
      <div className='otros-documents-grid3-columns home-dashboard'>
        {cards.map((card, i) => (
          <CardMenu
            key={i}
            className='otros-documents-card'
            classNameH2='otros-documents-card-title'
            to={card.to}
            activar={() => setActivo(card.activo)}
            desactivar={() => setActivo(0)}
            activo={activo === card.activo}
            title={card.titulo}
            description={card.descripcion}
            onClick={() => {
              handleActiveDoc(card)
            }}
            autoFocus={card.autoFocus}
            disabled={card.disabled}
          />
        ))}
      </div>
    </BasicLayout>
  )
}

export default OtrosDocumentosIndex
